
export function isNullOrUndefined(obj: any): obj is (null | undefined) {
  return obj === null || obj === undefined;
}
